"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _OnClickOutside = _interopRequireDefault(require("../../../OnClickOutside"));
var _Avatar = _interopRequireDefault(require("../../Clients/Avatar"));
var _CommunicationFilters = _interopRequireDefault(require("../CommunicationFilters"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _LogList = _interopRequireDefault(require("./components/LogList"));
var _Name = _interopRequireDefault(require("../../Clients/Name"));
var _LogRelations = _interopRequireDefault(require("../LogRelations"));
var _NoteForm = _interopRequireDefault(require("../../Notes/NoteForm"));
var _constants = require("../../../../constants");
var _excluded = ["contact", "hasNextPage", "isNextPageLoading", "selectedCallId", "logs", "onClickIcon", "onDelete", "relateTo", "filteredType", "onFilter", "onLoadRequest", "onPin", "onFlag", "onEdit", "onReasonDelete", "onReasonSubmit", "threshold", "types"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  hasNextPage: false,
  isNextPageLoading: false
};
var Logs = /*#__PURE__*/function (_React$PureComponent) {
  function Logs(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Logs);
    _this = _callSuper(this, Logs, [props]);
    _this.state = {
      isNoteFormOpen: false
    };
    _this.submitNote = _this.submitNote.bind(_this);
    _this.toggleForm = _this.toggleForm.bind(_this);
    _this.closeForm = _this.closeForm.bind(_this);
    _this.handleTypeChange = _this.handleTypeChange.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(Logs, _React$PureComponent);
  return (0, _createClass2["default"])(Logs, [{
    key: "handleTypeChange",
    value: function handleTypeChange(_ref) {
      var detail = _ref.detail;
      var onRelationChange = this.props.onRelationChange;
      var relateTo = detail.value[0];
      onRelationChange(relateTo);
    }
  }, {
    key: "submitNote",
    value: function submitNote(_ref2) {
      var value = _ref2.value;
      var _this$props = this.props,
        relateTo = _this$props.relateTo,
        onAdd = _this$props.onAdd;
      onAdd({
        value: value,
        relateTo: relateTo
      });
      this.closeForm();
    }
  }, {
    key: "toggleForm",
    value: function toggleForm() {
      this.setState(function (prevState) {
        return {
          isNoteFormOpen: !prevState.isNoteFormOpen
        };
      });
    }
  }, {
    key: "closeForm",
    value: function closeForm() {
      this.setState({
        isNoteFormOpen: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        contact = _this$props2.contact,
        hasNextPage = _this$props2.hasNextPage,
        isNextPageLoading = _this$props2.isNextPageLoading,
        selectedCallId = _this$props2.selectedCallId,
        logs = _this$props2.logs,
        onClickIcon = _this$props2.onClickIcon,
        onDelete = _this$props2.onDelete,
        relateTo = _this$props2.relateTo,
        filteredType = _this$props2.filteredType,
        onFilter = _this$props2.onFilter,
        onLoadRequest = _this$props2.onLoadRequest,
        onPin = _this$props2.onPin,
        onFlag = _this$props2.onFlag,
        onEdit = _this$props2.onEdit,
        onReasonDelete = _this$props2.onReasonDelete,
        onReasonSubmit = _this$props2.onReasonSubmit,
        threshold = _this$props2.threshold,
        types = _this$props2.types,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      var avatarUrl = contact.avatarUrl,
        fullName = contact.fullName;
      var isNoteFormOpen = this.state.isNoteFormOpen;
      return /*#__PURE__*/_react["default"].createElement(StyledLogs, props, /*#__PURE__*/_react["default"].createElement(StyledHead, null, /*#__PURE__*/_react["default"].createElement(StyledContact, null, /*#__PURE__*/_react["default"].createElement(StyledAvatar, {
        name: fullName,
        url: avatarUrl
      }), fullName && /*#__PURE__*/_react["default"].createElement(StyledName, {
        name: fullName
      }))), isNoteFormOpen ? /*#__PURE__*/_react["default"].createElement(StyledNoteFormContainer, {
        onClickOutside: this.closeForm
      }, /*#__PURE__*/_react["default"].createElement(StyledNoteForm, {
        onSubmit: this.submitNote,
        onCancel: this.closeForm
      })) : /*#__PURE__*/_react["default"].createElement(StyledNoteFormPlaceholder, {
        functional: true,
        onClick: this.toggleForm
      }, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043A\u0441\u0442 \u0437\u0430\u043C\u0435\u0442\u043A\u0438"), /*#__PURE__*/_react["default"].createElement(StyledLogRelations, {
        value: relateTo,
        onChange: this.handleTypeChange
      }), relateTo === _constants.LOG_RELATIONS.CLIENT && /*#__PURE__*/_react["default"].createElement(StyledCommunicationFilters, {
        values: filteredType,
        types: types,
        onChange: onFilter
      }), logs && /*#__PURE__*/_react["default"].createElement(StyledLogList, {
        logs: logs,
        relateTo: relateTo,
        hasNextPage: hasNextPage,
        isNextPageLoading: isNextPageLoading,
        selectedCallId: selectedCallId,
        onDelete: onDelete,
        onEdit: onEdit,
        onClickIcon: onClickIcon,
        onLoadRequest: onLoadRequest,
        onPin: onPin,
        onFlag: onFlag,
        onReasonDelete: onReasonDelete,
        onReasonSubmit: onReasonSubmit,
        threshold: threshold
      }));
    }
  }]);
}(_react["default"].PureComponent);
Logs.defaultProps = defaultProps;
var StyledLogs = _styledComponents["default"].div.withConfig({
  displayName: "Logs__StyledLogs",
  componentId: "sc-7rx5hi-0"
})(["background-color:#e6e6e6;display:flex;flex-direction:column;height:100%;overflow:hidden;padding:0 14px;"]);
var StyledHead = _styledComponents["default"].div.withConfig({
  displayName: "Logs__StyledHead",
  componentId: "sc-7rx5hi-1"
})(["display:flex;flex-shrink:0;margin-bottom:10px;"]);
var StyledCommunicationFilters = (0, _styledComponents["default"])(_CommunicationFilters["default"]).withConfig({
  displayName: "Logs__StyledCommunicationFilters",
  componentId: "sc-7rx5hi-2"
})(["margin-bottom:5px;"]);
var StyledLogRelations = (0, _styledComponents["default"])(_LogRelations["default"]).withConfig({
  displayName: "Logs__StyledLogRelations",
  componentId: "sc-7rx5hi-3"
})(["margin-bottom:10px;"]);
var StyledContact = _styledComponents["default"].div.withConfig({
  displayName: "Logs__StyledContact",
  componentId: "sc-7rx5hi-4"
})(["flex:1;display:flex;align-items:center;"]);
var StyledAvatar = (0, _styledComponents["default"])(_Avatar["default"]).withConfig({
  displayName: "Logs__StyledAvatar",
  componentId: "sc-7rx5hi-5"
})(["height:26px;width:26px;"]);
var StyledName = (0, _styledComponents["default"])(_Name["default"]).withConfig({
  displayName: "Logs__StyledName",
  componentId: "sc-7rx5hi-6"
})(["color:#17181a;", " + &{margin-left:8px;}"], StyledAvatar);
var StyledNoteFormContainer = (0, _styledComponents["default"])(_OnClickOutside["default"]).withConfig({
  displayName: "Logs__StyledNoteFormContainer",
  componentId: "sc-7rx5hi-7"
})(["height:40px;margin-bottom:15px;position:relative;"]);

// @ts-ignore: Skip jsx dependence check
var StyledNoteForm = (0, _styledComponents["default"])(_NoteForm["default"]).withConfig({
  displayName: "Logs__StyledNoteForm",
  componentId: "sc-7rx5hi-8"
})(["width:100%;padding:10px;border-radius:4px;background-color:#fffbe5;box-shadow:0 2px 20px 0 rgb(149 166 183 / 30%);position:absolute;z-index:5;"]);
var StyledNoteFormPlaceholder = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "Logs__StyledNoteFormPlaceholder",
  componentId: "sc-7rx5hi-9"
})(["background:white;border-radius:4px;color:#c2c5cc;font-size:14px;height:40px;line-height:40px;margin-bottom:10px;padding:0 8px;text-align:left;"]);
var StyledLogList = (0, _styledComponents["default"])(_LogList["default"]).withConfig({
  displayName: "Logs__StyledLogList",
  componentId: "sc-7rx5hi-10"
})(["::-webkit-scrollbar{width:4px;}::-webkit-scrollbar-thumb{background-color:#c2c5cc;border-radius:40px;}"]);
var _default = exports["default"] = Logs;